import { Component, OnInit } from '@angular/core';
import { UserCreatePayload } from '../../models/user-create-model';
import { NgForm } from '@angular/forms';
import { UserMasterService } from '../../services/user-master-service';
import { ConfigMasterService } from '../../services/config-master-service';
import { UtilityService } from 'src/app/modules/accounts-module/accounts/services/utility-service';
import { Router } from '@angular/router';
import { Role } from '../../models/user-role-model';
import { Location } from '@angular/common';
import { Template } from '../../models/template-model';
import { MatTableDataSource } from '@angular/material/table';
import { TemplateMasterService } from '../../services/template-master-service';

@Component({
  selector: 'app-template-master',
  templateUrl: './template-master.component.html',
  styleUrls: ['./template-master.component.css']
})
export class TemplateMasterComponent implements OnInit {

  public l_formData: Template = new Template();
  public isEditMode: boolean = false;
  private l_clientId: number;

  public dataSource = new MatTableDataSource<Template>();
  public l_daybookFilteredList: Template[] = [];
  public displayedColumns: string[] = [
    'srNo',
    'templateName',
    'dltTemplateId',
    'templateMsg',
    'templateIsActive',
    'actions'
  ];

  constructor(
    private l_UtilityService: UtilityService,
    private l_TemplateMasterService: TemplateMasterService
  ) { }

  ngOnInit(): void {
    const data = JSON.parse(sessionStorage.getItem('client_master'));
    this.l_clientId = data.clientId;
    // Defaults
    this.l_formData.templateIsActive = 'YES';
    this.lFN_GetTemplateList();
  }

  lFN_GetTemplateList() {
    this.l_UtilityService.lFN_ShowLoader();
    let l_response = this.l_TemplateMasterService.lFN_GetTemplateMasterList();
    l_response.subscribe({
      next: (res) => {
        console.log("res = ", res);
        let responselist = JSON.parse(res.body);
        this.dataSource.data = responselist?.data;
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to load template list',
          'Error'
        );
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_SubmitForm() {
    console.log("l_formData => ", this.l_formData);
    let l_formDataObject = this.l_formData;
    if (l_formDataObject.templateName == null || l_formDataObject.dltTemplateId == null || l_formDataObject.templateMsg == null) {
      this.l_UtilityService.lFN_WarningToaster('Please insert proper values for template name, ID, and message', 'Required fields missing');
      return;
    }
    // set clientID
    l_formDataObject.clientId = this.l_clientId;

    this.l_UtilityService.lFN_ShowLoader();
    let l_response = this.l_TemplateMasterService.lFN_SaveUpdateTemplate(l_formDataObject);
    l_response.subscribe({
      next: (response) => {
        console.log("response = ", response);
        if (response.status == 200) {
          this.l_UtilityService.lFN_SuccessToaster((response.body as any)?.message, 'Success');
          this.lFN_GetTemplateList();
        }
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to save template',
          'Error'
        );
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
        this.isEditMode = false;
        this.l_formData = new Template();
      }
    });
  }

  lFN_EditTemplate(l_templateData: Template) {
    console.log("l_templateData: ", l_templateData);
    this.l_formData = new Template({ ...l_templateData });
    this.isEditMode = true;
  }

  lFN_ChangeTemplateStatus(l_templateData: Template) {
    const newStatus = !l_templateData.templateIsActive;
    const statusLabel = newStatus ? 'Active' : 'Inactive';

    const dialogData = {
      title: `Change Template Status - ${l_templateData.templateName}`,
      message: `Are you sure you want to change status of ${l_templateData.templateName} to ${statusLabel}?`,
      buttons: [
        {
          label: 'Yes',
          value: true,
          color: 'primary',
          className: 'btn-yes-custom',
        },
        { label: 'No', value: false, color: 'warn' },
      ],
    };

    this.l_UtilityService
      .lFN_ShowConfirmationDialog(
        dialogData.title,
        dialogData.message,
        dialogData.buttons
      )
      .subscribe((confirmed) => {
        if (!confirmed) return;

        this.l_TemplateMasterService.lFN_ChangeTemplateStatus(l_templateData.templateId).subscribe({
          next: (response: any) => {
            l_templateData.templateIsActive = (newStatus ? 'YES' : 'NO');
            this.l_UtilityService.lFN_SuccessToaster(
              response?.body?.msg || 'Template status changed successfully',
              'Success'
            );
            this.lFN_GetTemplateList();
          },
          error: (err) => {
            const errorMsg = err.error?.msg || 'Failed to change Template status';
            this.l_UtilityService.lFN_ErrorToaster(errorMsg, 'Error');
          },
        });
      });
  }

  lFN_ResetForm() {
    this.isEditMode = false;
    this.l_formData = new Template();
  }

}
